import React, { Suspense } from 'react'
import {
  WithConfigurationContext,
  WithModalContext,
  WithMainNotificationContext,
  WithRouteStateContext,
  WithAssetsContext,
  WithProductFeatureContext,
} from '../modules/shared'
import { GenericModal } from '../components'
import { WithAuthContext } from '../modules/auth'
import { WithCache } from '../modules/shared/cache'
import { BaseInit } from './base-init'
import { ThemeProvider } from 'app/modules/shared/context/theme-context'
import { WithMonitoringContext } from 'app/modules/shared/context/monitoring/monitoring-context'

/**
 * All application wrapper components
 */
export function AppWrappers({ children }: { children?: React.JSX.Element }): React.JSX.Element {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <WithMainNotificationContext>
        <WithConfigurationContext>
          <WithAssetsContext>
            <WithProductFeatureContext>
              <WithCache>
                <WithRouteStateContext>
                  <WithAuthContext>
                    <WithMonitoringContext>
                      <ThemeProvider>
                        <WithModalContext>
                          <BaseInit />
                          {children!}
                          <GenericModal />
                        </WithModalContext>
                      </ThemeProvider>
                    </WithMonitoringContext>
                  </WithAuthContext>
                </WithRouteStateContext>
              </WithCache>
            </WithProductFeatureContext>
          </WithAssetsContext>
        </WithConfigurationContext>
      </WithMainNotificationContext>
    </Suspense>
  )
}
